import { createContext } from 'react';

const ImagesContext = createContext();

export default ImagesContext;
